export default __webpack_public_path__ + "static/og-image-bfe01ffd1c5376084ef08f94894e4645.jpg";